var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.5V5.51124M6 5.5V5.51124M10.5 5.5V5.51124M15 5.5V5.51124M19.5 5.5V5.51124M1.5 23.4888V23.5M6 23.4888V23.5M10.5 23.4888V23.5M15 23.4888V23.5M19.5 23.4888V23.5M19.5 18.9916V19.0028M19.5 14.4944V14.5056M19.5 9.99719V10.0084M1.5 18.9916V19.0028M1.5 14.4944V14.5056M1.5 9.99719V10.0084M6 9.99719H15V18.9916H6V9.99719Z",
    stroke: "#D6AF66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5L20.5 0.5",
    stroke: "#D6AF66",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 9.5,
    width: 8,
    height: 9,
    fill: "#D6AF66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterDown);
export default __webpack_public_path__ + "static/media/center-down.8f27f60f63f2406ff636c718db8ea88a.svg";
export { ForwardRef as ReactComponent };